<template>
  <div>
    <ad></ad>
    <div class="content">
      <inner-nav :innerData="navList[1]" :innerTitle="navList[1].navChildList[4].name" :innerLink="navList[1].navChildList[4].toLink"></inner-nav>
      <div class="contexts-content">
        <div class="contexts-title">
          <h1>企业荣誉</h1>
          <h3>Enterprise honor</h3>
        </div>
        <div class="contexts-detail">
          <ul class="honor">
            <li class="honor-item" v-for="(item,index) in listHonors" :key="index">
              <div>
                <span>{{item.year}}年</span>
              </div>
              <div>
                <i></i>
                <p v-html="item.content">{{item.content}}</p>
              </div>
            </li>
            <li class="honor-item">
              <div></div>
              <div></div>
            </li>
          </ul>

          <img :src="footerAd.imgUrl" alt="">

          <div class="swiper-contexts">
            <swiper v-if="listImages.length>1" :options="swiperOption">
              <swiper-slide v-for="(item,index) in [...listImages,...listImages,...listImages]" :key="index">
                <img class="swiper-img" :src="item.imgUrl">
              </swiper-slide>
            </swiper>
            <!--以下看需要添加-->
            <div class="swiper-button-prev">
              <div class="button-prev">
                <img src="../../../static/img/prev.png" alt="">
              </div>
            </div>
            <div class="swiper-button-next">
              <div class="button-next">
                <img src="../../../static/img/next.png" alt="">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="popup" v-if="isShow">
      <div class="mask"></div>
      <div class="popup-img">
        <img @click="closePopup" src="../../../static/img/close.png" alt="">
        <img :src="imgUrl" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  import ad from '../../components/advertisement'
  import InnerNav from '../../components/innerNav'
  let vm = null;
  export default {
    name: "",
    data(){
      return {
        isShow:false,
        imgUrl:'',
        footerAd:{},
        listImages:[],
        listHonors:[],
        //设置属性
        swiperOption:{
//          //显示分页
//          pagination: {
//            el: '.swiper-pagination',
//            clickable:true
//          },
          //切换模式  横屏或者竖屏
          // direction : 'vertical',
          //设置自动播放速度
//          autoplay: {
//            disableOnInteraction: false,
//            delay:4000
//          },
          //开启无限循环
          loop:true,
          //设置点击箭头
          paginationClickable :true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
//          prevButton:'.swiper-button-prev',
//          nextButton:'.swiper-button-next',低版本写法 高版本不可用
          //设置同屏显示的数量，默认为1，使用auto是随意的意思。
          slidesPerView:3,
          slidesPerGroup:1,
          spaceBetween:20,
          //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，或true使用默认值。
          on: {
            click: function (e) {
              // 这里有坑
              // 需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
              // console.log(this); // -> Swiper
              // 当前活动块的索引，与activeIndex不同的是，在loop模式下不会将 复制的块 的数量计算在内。
              const imgSrc = e.target.src;
              vm.handleClickSlide(imgSrc);
            }
          },
          preventLinksPropagation: false   // 阻止点击事件冒泡
        }
      }
    },
    components: {
      ad,
      InnerNav
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    methods:{
      handleClickSlide(imgSrc) {
        this.isShow=true;
        this.imgUrl=imgSrc
      },
      closePopup(){
        this.isShow=false;
      }

    },
    created(){
      vm = this;
      this.$http.get(`/outer/feifan/listHonors.do`).then((res)=>{
        this.listHonors=res.data
      })
      this.$http.get(`/outer/image/listImages.do`,{
        functionCode:4
      }).then((res)=>{
        this.listImages=res.data
      })
      this.$http.get(`/outer/image/listImages.do`,{
        functionCode:3
      }).then((res)=>{
        this.footerAd=res.data[0]
      })
    }
  }
</script>
<style scoped lang="less">
  .contexts-content{
    padding-bottom: .6rem;
    padding-top:.3rem;
    width:12rem;
      .contexts-title{
        padding-bottom:.3rem;
          h1{
            font-size:.24rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:.48rem;
          }
          h3{
            font-size:.14rem;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:.14rem;
          }
      }
      .contexts-detail{
        width:100%;
          .honor{
            border-top:1px solid #ccc;
            border-bottom:1px solid #ccc;
            margin-bottom:.1rem;
            width:100%;
              .honor-item{
                overflow: hidden;
                clear: both;
                width:100%;
                  >div:nth-child(1){
                     float: left;
                     padding-top:.5rem;
                      span{
                        display: block;
                        background:#999;
                        -webkit-border-radius:.6rem;
                        -moz-border-radius:.6rem;
                        border-radius:.6rem;
                        color: #fff;
                        font-size:.24rem;
                        text-align: center;
                        line-height:.5rem;
                        width:1.6rem;
                      }
                  }
                   >div:nth-child(2){
                      position: relative;
                      float: right;
                      width:10rem;
                      padding:.5rem 0;
                      border-left:1px solid #CCCCCC;
                        i{
                          position: absolute;
                          top:.64rem;
                          left:-.132rem;
                          width:.24rem;
                          height:.24rem;
                          background: #ccc;
                          -webkit-border-radius:50%;
                          -moz-border-radius:50%;
                          border-radius:50%;
                        }
                        p{
                          color: #333333;
                          font-size:.14rem;
                          line-height:.2rem;
                          padding-left:.5rem;
                        }
                    }
              }
          }
          img{
            width:100%;
            height:2rem;
          }
      }
      .swiper-img{
        cursor: pointer;
      }
  }
  .popup{
    position: fixed;
    height:100%;
    width:100%;
    left:0;
    top:0;
    z-index: 10;
    .mask{
      position: absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
      background: rgba(0,0,0,.5);
    }
    .popup-img{
      width:100%;
      height:100%;
        img:nth-child(1){
          height:.5rem;
          width:.5rem;
          position: absolute;
          right:1rem;
          top:.5rem;
          cursor: pointer;
        }
        img:nth-child(2){
          position: absolute;
          left:calc(50% - 3rem);
          top:calc(50% - 2rem);
          width:6rem;
          height:4rem;
        }
    }
  }
</style>
<style lang="less">
  .swiper-contexts{
    position: relative;
    margin: 0 auto;
    margin-top:.5rem;
    width:10.2rem;
    height:2rem;
      .swiper-slide{
        height:2rem;
      }
      .swiper-button-next,.swiper-button-prev{
        height:.5rem;
        width:.5rem;
        outline: none;
        background-image: none;
      }
      .swiper-button-next{
        right:-.8rem;
          .button-next{
            width:100%;
            height:100%;
              img{
                width:100%;
                height:100%;
              }
          }
      }
      .swiper-button-prev{
        left:-.8rem;
          .button-prev{
            width:100%;
            height:100%;
              img{
                width:100%;
                height:100%;
              }
          }
      }

  }
</style>



// WEBPACK FOOTER //
// src/pages/group/contexts.vue